// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase:{
    apiKey: "AIzaSyBMhDpnnbFQVnrFXlM3I37Au0vXuvCxHPg",
    authDomain: "foodapp-clone.firebaseapp.com",
    databaseURL: "https://foodapp-clone.firebaseio.com",
    projectId: "foodapp-clone",
    storageBucket: "foodapp-clone.appspot.com",
    messagingSenderId: "678101669131",
    appId: "1:678101669131:web:4e47149640e7f839507e0e",
    measurementId: "G-M085C4WF7R"
  }
};

  // firebase: {
  //   apiKey: "AIzaSyDPNI7n3qKHFZGwZ_pYz3tls8B1Py7OVe8",
  //   authDomain: "juristway.firebaseapp.com",
  //   databaseURL: "https://juristway.firebaseio.com",
  //   projectId: "juristway",
  //   storageBucket: "juristway.appspot.com",
  //   messagingSenderId: "722795618273",
  //   appId: "1:722795618273:web:b900b539ddf2e80d"
  // } 

